module.exports = __FOREMAN_VENDOR__REDUX_LOGGER__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REDUX_LOGGER__"
// module id = redux-logger
// module chunks = 0 1 2